/**
 * Hotspots functionality for shop-the-look module.
 * Desktop: Shows tooltips on hover (original behavior)
 * Mobile: Shows selected product in fixed container below "Shop the look"
 */
(function () {
  // Add class on the hotspot when promo prod is equal - on hover
  const inspHotspots = document.querySelectorAll(".hotspot");
  const promoProdsContainer = document.querySelector(".hotspot-items");

  if (promoProdsContainer) {
    promoProdsContainer.addEventListener("mouseover", function (e) {
      const parentContainer = e.target.closest(".hotspot-item");
      inspHotspots.forEach((hotspot) => {
        hotspot.classList.remove("active");
        if (hotspot.getAttribute("data-value") == parentContainer.querySelector('[data-name="promo-anchor-prod-item"]').id) {
          hotspot.classList.add("active");
        }
      });
    });

    promoProdsContainer.addEventListener("mouseleave", function () {
      inspHotspots.forEach((hotspot) => {
        hotspot.classList.remove("active");
      });
    });
  }

  function focusIdItemShopTheLook(e) {
    let idItemValue = e.target.getAttribute("data-value");
    document.getElementById(idItemValue).parentElement.classList.add("active");
    setTimeout(() => {
      document.getElementById(idItemValue).parentElement.classList.remove("active");
    }, 1000);
  }

  // Check if we're on mobile
  function isMobile() {
    return window.innerWidth <= 640;
  }

  // Show product in fixed container (mobile only)
  function showProductInContainer(productId) {
    if (!isMobile()) return; // Only work on mobile

    const productElement = document.getElementById(productId);
    if (!productElement) return;

    const productContainer = productElement.closest('.hotspot-item');
    if (!productContainer) return;

    // Get product data from the container
    const productImage = productContainer.querySelector('.horizontal-product-card__image');
    const productTitle = productContainer.querySelector('.product-title');
    const productColor = productContainer.querySelector('.product-color');
    const productPrice = productContainer.querySelector('.price-list');
    const productLink = productContainer.querySelector('.horizontal-product-card__info');
    const productAddToCartBtn = productContainer.querySelector('.AddToCartFrom');

    // Update the fixed display container
    const displayContainer = document.getElementById('selected-product-display');
    const displayImage = document.getElementById('selected-product-img');
    const displayTitleLink = document.getElementById('selected-product-title-link');
    const displayVariant = document.getElementById('selected-product-variant');
    const displayPrice = document.getElementById('selected-product-price');
    const displayLink = document.getElementById('selected-product-link');
    const displayAddToCartBtn = document.getElementById('selected-product-add-to-cart');

    if (displayContainer && displayImage && displayTitleLink && displayVariant && displayPrice && displayLink && displayAddToCartBtn) {
      // Update content
      if (productImage) {
        displayImage.src = productImage.src;
        displayImage.alt = productImage.alt;
      }

      if (productTitle) {
        displayTitleLink.textContent = productTitle.textContent.trim();
      }

      if (productColor) {
        displayVariant.textContent = productColor.textContent.trim();
      }

      if (productPrice) {
        displayPrice.innerHTML = productPrice.innerHTML;
      }

      if (productLink) {
        displayLink.href = productLink.href;
        displayTitleLink.href = productLink.href;
        displayLink.setAttribute('data-product_id', productId);
        displayTitleLink.setAttribute('data-product_id', productId);
      }

      // Update Add to Cart button
      if (productAddToCartBtn) {
        displayAddToCartBtn.setAttribute('data-variant_id', productAddToCartBtn.getAttribute('data-variant_id'));
        displayAddToCartBtn.style.opacity = productAddToCartBtn.style.opacity;
        displayAddToCartBtn.style.pointerEvents = productAddToCartBtn.style.pointerEvents;
      }

      // Show the container
      displayContainer.style.display = 'block';
    }
  }

  // Add event listeners to hotspots
  document.querySelectorAll('[data-name="custom-hotspot"]').forEach((hotspot) => {
    // Desktop hover (original behavior)
    hotspot.addEventListener("mouseover", function (e) {
      focusIdItemShopTheLook(e);
      // Only show in fixed container on mobile
      if (isMobile()) {
        const productId = hotspot.getAttribute("data-value");
        showProductInContainer(productId);
      }
    });

    // Mobile/tablet click and touch
    hotspot.addEventListener("click", function (e) {
      if (isMobile()) {
        e.preventDefault();
        const productId = hotspot.getAttribute("data-value");
        showProductInContainer(productId);
      }
    });

    hotspot.addEventListener("touchstart", function (e) {
      if (isMobile()) {
        e.preventDefault();
        const productId = hotspot.getAttribute("data-value");
        showProductInContainer(productId);
      }
    });
  });
})();
